import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Edition } from '../models/edition.model';

@Injectable({
  providedIn: 'root'
})
export class EditionService {

  private apiUrl = 'https://be.festivalsousse.com/api/editions';

  constructor(private http: HttpClient) { }

  getEditions(): Observable<Edition[]> {
    return this.http.get<Edition[]>(this.apiUrl);
  }

  createEdition(edition: Edition): Observable<Edition> {
    return this.http.post<Edition>(this.apiUrl, edition);
  }

  updateEdition(id: number, edition: Edition): Observable<Edition> {
    return this.http.put<Edition>(`${this.apiUrl}/${id}`, edition);
  }

  deleteEdition(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}
